import * as z from "zod/mini";

export interface ApiResource {
  /**
   * ID unique to this resource type
   */
  id: number;
}

/**
 * Utility type removing the `id` field from an {@linkcode ApiResource} since it's unknown at the time of creation
 */
export type CreateResource<T extends ApiResource> = Omit<T, "id">;
/**
 * Utility type making all properties except for `id` optional for partial updates
 */
export type UpdateResource<T extends ApiResource> = ApiResource & Partial<CreateResource<T>>;

export const makeApiResource = <T extends z.core.$ZodShape>(schema: T) =>
  z.object({
    id: z.coerce.number().check(z.nonnegative()),
    ...schema,
  });
